import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { FaExternalLinkAlt } from "react-icons/fa";
import { ClipboardDocumentIcon } from "@heroicons/react/24/solid";
const MultiLinks = ({ taskDetail, setIsLoading, reloadData }) => {
  const [originalUrls, setOriginalUrls] = useState([]);
  const [urls, setUrls] = useState([]);

  useEffect(() => {
    if (taskDetail?.social_bookmarking) {
      const initialUrls = taskDetail?.social_bookmarking.map((item) => ({
        backlink_id: item.id,
        live_url: item.live_url || "",
        ml_id: item.ml_id || "",
      }));
      setUrls(initialUrls);
      setOriginalUrls(initialUrls);
    }
  }, [taskDetail]);

  const handleUrlChange = (e, backlinkId) => {
    const updatedUrls = urls.map((item) =>
      item.backlink_id === backlinkId
        ? { ...item, live_url: e.target.value }
        : item
    );
    setUrls(updatedUrls);
  };

  const handleSave = () => {
    const finalData = {
      multilinks: urls
        ?.filter((item) => item.live_url?.trim() !== "")
        .map((item) => ({
          backlink_id: item.backlink_id,
          live_url: item.live_url,
          ml_id: item.ml_id || "",
        })),
      task_id: taskDetail.id,
    };

    if (finalData.multilinks.length === 0) {
      toast.error("Please provide at least one valid live URL before saving.");
      return;
    }
    setIsLoading(true);
    api
      .post(`api/linkbuilder_user/update_multilink`, finalData)
      .then((res) => {
        const status = res.status;
        if (status === 200 || status === 201) {
          reloadData();
          toast.success(res?.data?.message || "Child Task added.");
        } else {
          toast.warn("Unexpected response from server.");
        }
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || err.message || "An error occurred"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCancel = () => {
    setUrls(originalUrls);
  };

  const handleCopyContent = (content, message) => {
    // Copy the content to the clipboard
    if (!content) {
      toast.info(`no record`, { autoClose: 2000 });
      return;
    }
    navigator.clipboard.writeText(content);
    toast.success(`${message} copied to clipboard!`, { autoClose: 2000 });
  };

  return (
    <>
      {taskDetail?.social_bookmarking ? (
        <>
          <div className="flex flex-row justify-between items-center mt-5">
            <p className="text-lg font-bold">Multi Links</p>
          </div>
          <div className="text-sm">
            <div className="bg-white dark:bg-white/20 backdrop-blur-lg text-sm shadow-xl dark:shadow-black px-4 py-4 rounded-md flex flex-col min-h-[100px] max-h-[500px] overflow-y-auto border dark:border-white/20">
              <div className="relative overflow-x-auto">
                <table className="min-w-full table-auto">
                  <thead className="sticky top-0 z-10 bg-white dark:bg-white/20 dark:shadow-black text-sm text-left text-gray-600 dark:text-gray-300 border-b border-gray-200 dark:border-gray-700">
                    <tr>
                      <th className="px-4 py-2 text-md font-semibold text-black w-[30%]">
                        Backlink Domain (
                        {taskDetail?.social_bookmarking?.length})
                      </th>
                      <th className="px-4 py-2 text-md font-semibold text-black w-[70%]">
                        Live URL
                      </th>
                    </tr>
                  </thead>
                  <tbody className="max-h-[400px] overflow-y-auto">
                    {taskDetail?.social_bookmarking?.map((item) => (
                      <tr
                        key={item.id}
                        className="hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-dashed mt-1"
                      >
                        <td className="px-2 py-2 w-[40%] pl-8">
                          {item.backlink_domain}
                        </td>

                        <td className="px-2 py-2 w-[60%]">
                          <div className="flex border rounded-lg overflow-hidden">
                            <a
                              href={
                                urls.find(
                                  (url) => url.backlink_id === item.id
                                ) !== undefined
                                  ? urls.find(
                                      (url) => url.backlink_id === item.id
                                    ).live_url
                                  : item?.live_url || ""
                              }
                              onClick={(e) => {
                                const url =
                                  urls.find(
                                    (url) => url.backlink_id === item.id
                                  ) !== undefined
                                    ? urls.find(
                                        (url) => url.backlink_id === item.id
                                      ).live_url
                                    : item?.live_url || "";
                                if (!url) {
                                  e.preventDefault();
                                  toast.info("No record");
                                }
                              }}
                              target="_blank"
                              rel="noreferrer"
                              className="flex items-center px-4 py-2 bg-gray-200 hover:bg-gray-300 border-r border-gray-100"
                            >
                              <FaExternalLinkAlt />
                            </a>
                            <button
                              onClick={() =>
                                handleCopyContent(
                                  urls.find(
                                    (url) => url.backlink_id === item.id
                                  ) !== undefined
                                    ? urls.find(
                                        (url) => url.backlink_id === item.id
                                      ).live_url
                                    : item?.live_url || "",
                                  "Live URL"
                                )
                              }
                              className="flex items-center px-4 py-2 bg-gray-200 hover:bg-gray-300"
                            >
                              <ClipboardDocumentIcon className="w-5 cursor-pointer text-black hover:text-gray-600" />
                            </button>
                            <input
                              type="text"
                              value={
                                urls.find(
                                  (url) => url.backlink_id === item.id
                                ) !== undefined
                                  ? urls.find(
                                      (url) => url.backlink_id === item.id
                                    ).live_url
                                  : item?.live_url || ""
                              }
                              className="px-4 py-2 outline-none flex-grow"
                              placeholder="Enter text here"
                              onChange={(e) => handleUrlChange(e, item.id)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-end gap-2 mt-4">
            <button
              type="button"
              className="btnPrimary bg-gray-500"
              onClick={handleCancel}
            >
              Reset
            </button>
            <button onClick={handleSave} className="btnPrimary bg-green-600">
              Save
            </button>
          </div>
        </>
      ) : null}
    </>
  );
};

export default MultiLinks;
